<script lang="ts">
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { getCopy } from "../../lib/stores/copy";
  import LanguageSelector from "./LanguageSelector.svelte";

  export let onSelect: () => void;

  $: copy = $getCopy("layout") as Record<string, string>;
</script>

<div class="flex flex-col items-center h-full">
  <div class="title flex items-center lg:items-start gap-6 flex-col px-6 py-2 mt-8 lg:py-4 lg:mt-0 w-full">
    <Typography mobile={TypographyType.Headline1} desktop={TypographyType.Headline1} copy={copy.changeLanguageLinkCopy} />
  </div>
  <div class="px-6 w-full py-4 overflow-y-scroll overflow-x-hidden gap-3 flex flex-col">
    <LanguageSelector {onSelect} />
  </div>
</div>

<style>
  @media (min-width: 1024px) {
    .title {
      border-bottom: 1px solid var(--color-grayscale-30);
    }
  }
</style>
